import { render, staticRenderFns } from "./PengajuanBarangRusak.vue?vue&type=template&id=0688dfce&"
import script from "./PengajuanBarangRusak.vue?vue&type=script&lang=js&"
export * from "./PengajuanBarangRusak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports